import general from './general/main'
import loginProviders from './loginProviders/main'
import organisations from './organisations/main'
import users from './users/main'

export default {
    selected: 'Selected',

    general,
    users,
    organisations,
    loginProviders,
}